module.exports = __webpack_public_path__ + "img/oper-img.f647b4ac.png";